<template>
  <div class="authenticate">
    <div class="p-4 float-right">
      <router-link :to="{ name:'Register' }" class="ar-btn size-md round primary">ثبت نام</router-link>
    </div>
    <router-link :to="{name:'Home'}" class="p-2 float-left">
      <img class="logo-top" :src="this.StaticImageUrl+'assets/images/logo/logo-dark.png'">
    </router-link>

    <div class="form-out">
      <div class="form-in text-center">

        <div class="icon-lg">
          <div class="icon-wrapper">
            <img :src="this.StaticImageUrl+'assets/images/site-icons/verify-code.png'" alt="">
          </div>
        </div>

        <div class="input">
          <div class="input-wrapper mb-3">
            <CodeInput :loading="false" :fieldWidth="30" class="input" v-on:change="onChange" v-on:complete="onComplete" />
          </div>
        </div>
        <div v-if="errors.code" class="ar-form-text">
          <small>کد فعالسازی باید 6 رقم باشد.</small>
        </div>
        <div v-if="errorMessage" class="ar-alert danger round mb-3">
          <small>{{errorMessage}}</small>
        </div>
      
        <div class="mb-4">
          <button @click="VerifyCode" class="ar-btn size-md block round primary">تایید کد فعال سازی</button>
        </div>
        
      </div>
    </div>

  </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";
export default {
  name: 'EmailVerifyCode',
  components : {
    CodeInput
  },
  data : () => ({
    data:{
      code:'',
      email:''
    },
    errorMessage : null,
    errors : {}
  }),
  methods:{
    onChange(v) {
      this.data.code = v
    },
    onComplete(v) {
      this.VerifyCode();
    },
    VerifyCode(){
      this.activeLoading(true)
      this.$axios.post(`emailCodeVerify` , this.data)
      .then(res => {
        const data = res.data.data;
        this.$cookies.set("api_token", data.token , 60*60);
        this.authUser(data)
        this.activeLoading(false)
      })
      .catch(err => {
        if(err.response.data.message){
          this.errorMessage = err.response.data.message
          this.errors = {}
        }else if(err.response.data.errors){
          this.errors = err.response.data.errors
          this.errorMessage = null
        }
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
  },
  beforeMount(){
    this.checkUnAuthenticated()
    if(!this.user_email){
      this.$router.replace({name:'LoginByEmail'});
    }else{
      this.data.email = this.user_email;
    }
  }
}
</script>
<style>
.react-code-input-container{
  margin: auto;
  direction: ltr !important;
  width: 250px !important;
}
.react-code-input > input{
  border-bottom: 3px solid #003b6d !important;
  border-right: none !important;
  border-left: none !important;
  border-top: none !important;
  margin:0 5px !important;
  /* width:45px !important; */
  height:45px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  font-family: IRANSans !important;
}
</style>